import React from "react";
import { View } from "react-native";
import { Button } from "../../Core/Button/Button";
import { Heading } from "../../Core//Heading/Heading";
import { Text } from "../../Core/Text/Text";
import { Pill } from "../../Core/Pill/Pill";
import { Panel } from "../../Core/Panel/Panel";
import { styles, ids } from "./CTA.styles";
import { theme } from "../../theme";
import { useResponsive } from "../../Hooks";
export const CTA = ({ heading, subheading, textColor = "light", orientation = "portrait", pill, button, image, background = "brand", children, styles: userStyles, contentStyles, ...rest }) => {
    const { screens: { medium }, } = useResponsive();
    const imageSize = {
        width: medium ? 110 : 100,
        height: medium ? 110 : 100,
    };
    const PortraitBody = () => (React.createElement(View, { style: styles.portraitWrap },
        image && React.createElement(View, { style: imageSize }, image),
        React.createElement(View, { style: [contentStyles, { marginTop: 20 }] },
            heading &&
                (typeof heading === "string" ? (React.createElement(Heading, { level: 6, styles: styles.heading, color: textColor, dataSet: { media: ids.heading } }, heading)) : (heading)),
            subheading &&
                (typeof subheading === "string" ? (React.createElement(Text, { fontSize: "small", color: "brand", style: {
                        marginHorizontal: "auto",
                        textAlign: "center",
                    } }, subheading)) : (subheading)),
            medium && button && (React.createElement(Button, { onPress: button.onPress, size: "medium", color: "warning", styles: {
                    marginTop: theme.spacing.small,
                    width: 200,
                } },
                React.createElement(Text, { fontSize: "small", styles: { fontFamily: "ProximaSemiBold" } }, button.children)))),
        children));
    const LandscapeBody = () => (React.createElement(React.Fragment, null,
        React.createElement(View, { style: styles.landscapeWrap },
            image && (React.createElement(View, { style: [imageSize, { marginVertical: theme.spacing.small }] }, image)),
            React.createElement(View, { style: [
                    contentStyles,
                    {
                        alignItems: "center",
                    },
                ] },
                heading &&
                    (typeof heading === "string" ? (React.createElement(Heading, { level: 5, styles: styles.heading, color: textColor }, heading)) : (heading)),
                subheading &&
                    (typeof subheading === "string" ? (React.createElement(Text, { fontSize: "xsmall", color: textColor, style: {
                            textAlign: "center",
                        } }, subheading)) : (subheading)),
                medium && button && (React.createElement(View, { style: styles.button },
                    React.createElement(Button, { onPress: button.onPress, size: "medium", color: "warning", variant: "outline" },
                        React.createElement(Text, { fontSize: "small" }, button.children)))))),
        children && React.createElement(View, { style: styles.children }, children)));
    return (React.createElement(React.Fragment, null,
        React.createElement(Panel, { styles: [styles.wrapper, userStyles], color: background, shadow: true, rounded: true, testID: "cta-component", ...rest },
            orientation === "portrait" && React.createElement(PortraitBody, null),
            orientation === "landscape" && React.createElement(LandscapeBody, null)),
        pill && (React.createElement(View, { style: styles.pillWrapper },
            React.createElement(Pill, { color: "usp" }, pill)))));
};
//# sourceMappingURL=CTA.js.map